import "./NewMenuManagementPage.css";
import {
  MenuService,
  RestaurantService,
} from "deliziora-client-module/client-web";
import React, { useEffect, useState } from "react";
import PlusIcon from "../../Images/PlusIcon.svg";
import ProductsComponent from "../../Components/productsComponent/products";
import {
  Button,
  ConfigProvider,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  notification,
  Select,
  Typography,
} from "antd";

export default function NewMenuManagementPage({ isMobile }) {
  const [plates, setPlates] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [productSelected, setProductSelected] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [formRef] = Form.useForm();

  const firstLetterUpperCase = (word) => {
    const newWord = word.charAt(0).toUpperCase() + word.slice(1);
    word = newWord;
    return word;
  };
  const handleCancel = () => {
    formRef.resetFields();
    setProductSelected({});
    setIsModalOpen(false);
    setIsEdit(false);
  };
  function callBackClickEditProduct(value) {
    console.log("CALL BACK CLICKED ");
    console.log(value);
    setProductSelected(value);
    showEditProduct();
  }



  function callBackClickMenuCompleteProduct(values) {
    MenuService.updateMenuById({
      id_menu: values._id.$oid,
      name: values.name,
      description: values.description,
      category: values.category,
      price: String(values.price),
      menu_complete: true,
      img: "",
    })
      .then((res) => {
        MenuService.returnAllMenu()
          .then((res) => {
            const filteredDataByRestaurantId = res.data.filter(
              (item) =>
                item.id_Restaurants === userData._id.$oid &&
                item.menu_complete === false
            );
            const groupByCategory = filteredDataByRestaurantId.reduce(
              (group, product) => {
                const { category } = product;
                group[category] = group[category] ?? [];
                group[category].push(product);
                return group;
              },
              {}
            );
            setPlates(groupByCategory);
          })
          .catch((err) => {
            console.error("ERROR ", err);
          });
        notification.open({
          message: "Prato Atualizado com sucesso 🍽",
        });
      })
      .catch((err) => {
        console.error(err);
        notification.open({
          message: "Erro ao atualizar prato 🍽",
        });
      });
  }

  function callBackClickEspecialityProduct(plateName) {
    console.log({
      id_restaurant: userData._id.$oid,
      name: userData.name,
      address: userData.address,
      latitude: userData.latitude,
      especialty: plateName,
      complete_menu: userData.complete_menu,
      email: userData.email,
      opening_hours: userData.opening_hours,
      longitude: userData.longitude,
      contact: userData.contact,
      description: userData.description,
      img: userData.img,
      categories: userData.categories,
      characteristics: userData.characteristics,
      updated_at: "",
    })
    RestaurantService.updateRestaurantById({
      id_restaurant: userData._id.$oid,
      name: userData.name,
      address: userData.address,
      latitude: userData.latitude,
      especialty: plateName,
      complete_menu: userData.complete_menu,
      email: userData.email,
      opening_hours: userData.opening_hours,
      longitude: userData.longitude,
      contact: userData.contact,
      description: userData.description,
      img: userData.img,
      categories: userData.categories,
      characteristics: userData.characteristics,
      updated_at: "",
    })
      .then((res) => {
        RestaurantService.returnRestaurantById(userData._id.$oid)
          .then((res) => {
            localStorage.setItem("userData", JSON.stringify(res.data));
            MenuService.returnAllMenu()
              .then((res) => {
                const filteredDataByRestaurantId = res.data.filter(
                  (item) =>
                    item.id_Restaurants === userData._id.$oid &&
                    item.menu_complete === false
                );
                const groupByCategory = filteredDataByRestaurantId.reduce(
                  (group, product) => {
                    const { category } = product;
                    group[category] = group[category] ?? [];
                    group[category].push(product);
                    return group;
                  },
                  {}
                );
                setPlates(groupByCategory);
              })
              .catch((err) => {
                console.error("ERROR ", err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
        notification.open({
          message: `${plateName} adionado á especialidade do restaurante ${userData.name} 🍽`,
        });
      })
      .catch((err) => console.error(err));
  }

  function callBackClickDeleteProduct(value) {
    console.log("CALL BACK DELETE ");
    console.log(value);
    MenuService.deleteMenuById(value)
      .then(() => {
        notification.open({
          message: "Prato Apagado com sucesso 🍽",
        });
        MenuService.returnAllMenu()
          .then((res) => {
            const filteredDataByRestaurantId = res.data.filter(
              (item) =>
                item.id_Restaurants === userData._id.$oid &&
                item.menu_complete === false
            );
            const groupByCategory = filteredDataByRestaurantId.reduce(
              (group, product) => {
                const { category } = product;
                group[category] = group[category] ?? [];
                group[category].push(product);
                return group;
              },
              {}
            );
            setPlates(groupByCategory);
          })
          .catch((err) => {
            console.error("ERROR ", err);
          });
      })
      .catch((err) => {
        console.error(err);
        notification.open({
          message: "Erro ao Apagar prato 🍽",
        });
      });
  }
  const showEditProduct = () => {
    setIsEdit(!isEdit);
    setIsModalOpen(true);
  };
  const onFinishSuccess = (values) => {
    if (isEdit) {
      handleCancel();
      MenuService.updateMenuById({
        id_menu: values._id.$oid,
        name: values.name,
        description: values.description,
        category: values.category,
        price: String(values.price),
        menu_complete: false,
        img: "",
      })
        .then((res) => {
          MenuService.returnAllMenu()
            .then((res) => {
              const filteredDataByRestaurantId = res.data.filter(
                (item) =>
                  item.id_Restaurants === userData._id.$oid &&
                  item.menu_complete === false
              );
              const groupByCategory = filteredDataByRestaurantId.reduce(
                (group, product) => {
                  const { category } = product;
                  group[category] = group[category] ?? [];
                  group[category].push(product);
                  return group;
                },
                {}
              );
              setPlates(groupByCategory);
            })
            .catch((err) => {
              console.error("ERROR ", err);
            });
          notification.open({
            message: "Prato Atualizado com sucesso 🍽",
          });
        })
        .catch((err) => {
          console.error(err);
          notification.open({
            message: "Erro ao atualizar prato 🍽",
          });
        });
      setIsEdit(false);
    } else {
      MenuService.addNewMenu({
        id_restaurants: userData._id.$oid,
        name: values.name,
        description: values.description,
        category: values.category,
        price: String(values.price),
        menu_complete: false,
        img: "",
      })
        .then((data) => {
          handleCancel();
          MenuService.returnAllMenu()
            .then((res) => {
              const filteredDataByRestaurantId = res.data.filter(
                (item) =>
                  item.id_Restaurants === userData._id.$oid &&
                  item.menu_complete === false
              );
              const groupByCategory = filteredDataByRestaurantId.reduce(
                (group, product) => {
                  const { category } = product;
                  group[category] = group[category] ?? [];
                  group[category].push(product);
                  return group;
                },
                {}
              );
              setPlates(groupByCategory);
            })
            .catch((err) => {
              console.error("ERROR ", err);
            });
          notification.open({
            message: "Prato Adicionado com sucesso 🍽",
          });
        })
        .catch((err) => {
          console.error(err);
          notification.open({
            message: "Erro ao adicionar prato 🍽",
          });
        });
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const onFinishFailed = () => {
    setIsEdit(!isEdit);
  };
  const handleInputChange = (e) => {
    const inputText = e.target.value;
    setCharCount(inputText.length);
    if (inputText.length === 300) {
      message.warning("Limite de caracteres atingido!");
    }
  };

  formRef.setFieldsValue(productSelected);

  useEffect(() => {
    MenuService.returnAllMenu()
      .then((res) => {
        const filteredDataByRestaurantId = res.data.filter(
          (item) =>
            item.id_Restaurants === userData._id.$oid &&
            item.menu_complete === false
        );
        const groupByCategory = filteredDataByRestaurantId.reduce(
          (group, product) => {
            const { category } = product;
            group[category] = group[category] ?? [];
            group[category].push(product);
            return group;
          },
          {}
        );
        setPlates(groupByCategory);

      })
      .catch((err) => {
        console.error("ERROR ", err);
      });
  }, []);
  return (
    <Flex
      vertical
      align={isMobile ? "center" : ""}
      justify={isMobile ? "center" : ""}
    >
      <Typography.Title
        style={{ alignSelf: "center", padding: "1rem 0 1rem 0" }}
        level={2}
      >
        Pratos do dia
      </Typography.Title>
      <Flex
        vertical
        align={isMobile ? "center" : ""}
        justify={isMobile ? "center" : ""}
      >
        {Object.keys(plates).map((key, index) => {
          return (
            <>
              <div
                key={key + index}
                className="products_category_box"
                style={{ width: isMobile ? "90vw" : "" }}
              >
                <div className="products_category_text">
                  {firstLetterUpperCase(key)}
                </div>
                <ProductsComponent
                  callBackClickEditProduct={callBackClickEditProduct}
                  callBackClickDeleteProduct={callBackClickDeleteProduct}
                  callBackClickEspecialityProduct={
                    callBackClickEspecialityProduct
                  }
                  callBackClickMenuCompleteProduct={
                    callBackClickMenuCompleteProduct
                  }
                  products={plates[key]}
                />
              </div>
            </>
          );
        })}
      </Flex>

      <div>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                colorPrimary: "black",
                colorPrimaryHover: "rgba(243, 101, 39, 1)",
              },
            },
          }}
        >
          <Button 
          style={{
            alignSelf: "center",
            backgroundColor: "black",
            borderRadius: "100px",
            color: "white",
          }}
           onClick={() => showModal()}>
            Adicionar novo Prato
          </Button>
        </ConfigProvider>
      </div>

      <Modal
        title={isEdit ? "Editar Prato" : "Adicionar prato"}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimary: "black",
                    colorPrimaryHover: "rgba(243, 101, 39, 1)",
                  },
                },
              }}
            >
              <Button
                className="box_top_plates_button_modal"
                onClick={() => formRef.submit()}
              >
                Salvar
              </Button>
            </ConfigProvider>
          </div>
        }
      >
        <Form
          layout="vertical"
          onFinish={onFinishSuccess}
          onFinishFailed={onFinishFailed}
          form={formRef}
        >
          <Form.Item label="Id" name={["_id", "$oid"]} hidden>
            <Input />
          </Form.Item>
          <Form.Item label="Id" name="img" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label="Selecionar Categoria"
            name="category"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select>
              <Select.Option value="Carne">Carne</Select.Option>
              <Select.Option value="Peixe">Peixe</Select.Option>
              <Select.Option value="Vegetariano">Vegetariano</Select.Option>
              <Select.Option value="Entradas">Entradas</Select.Option>
              <Select.Option value="Salada">Salada</Select.Option>
              <Select.Option value="Sobremesa">Sobremesa</Select.Option>
              <Select.Option value="Outros">Outros</Select.Option>
            </Select>
          </Form.Item>
          <div style={{ display: "flex", gap: "2rem" }}>
            <Form.Item
              label="Nome do Prato"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Valor do Prato"
              name="price"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber />
            </Form.Item>
          </div>
          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.TextArea maxLength={300} onChange={handleInputChange} />
          </Form.Item>
        </Form>
      </Modal>
    </Flex>
  );
}
